import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import CreateOrganizationPopup from "../../components/common/CreateOrganizationPopup/CreateOrganizationPopup.tsx";
import SelectOrganizationPopup from "../../components/common/SelectOrganizationPopup/SelectOrganizationPopup.tsx";
import { useAppStore } from "../../hooks/useStores";
import { UserOrganization } from "../../models/organization.ts";

function McpAuth() {
	const { authStore } = useAppStore();
	const [showCreateOrgModal, setShowCreateOrgModal] = useState(false);
	const [showSelectOrgModal, setShowSelectOrgModal] = useState(false);
	const [selectOrgPopupButtonLoading, setSelectOrgPopupButtonLoading] = useState(false);
	const queryParams: URLSearchParams = new URLSearchParams(location.search);
	const state = queryParams.get("state");
	const redirectUri = new URL(queryParams.get("redirect_uri") ?? "");

	const handleSelectOrg = async (selectedOrgVal: UserOrganization | null | undefined) => {
		if (!selectedOrgVal) return;
		redirectToUri(selectedOrgVal);
	};

	const redirectToUri = (targetOrg: UserOrganization) => {
		if (redirectUri && targetOrg && state) {
			setSelectOrgPopupButtonLoading(true);
			redirectUri.searchParams.append("code", targetOrg?.organization.uid);
			redirectUri.searchParams.append("state", state);
			window.location.replace(redirectUri.toString());
		}
	};

	useEffect(() => {
		if (authStore.user && !authStore.isLoadingUserOrganizations) {
			if (authStore.userOrganizations.length === 0) {
				localStorage.setItem("destination_route", window.location.href);
				setShowCreateOrgModal(true);
			} else if (authStore.userOrganizations.length === 1) {
				redirectToUri(authStore.userOrganizations[0]);
			} else if (authStore.userOrganizations.length > 1) {
				setShowSelectOrgModal(true);
			}
		}
	}, [authStore.user, authStore.isLoadingUserOrganizations]);

	return (
		<>
			<SelectOrganizationPopup
				open={showSelectOrgModal}
				onClose={handleSelectOrg}
				buttonLoading={selectOrgPopupButtonLoading}
			/>
			<CreateOrganizationPopup open={showCreateOrgModal} onClose={() => setShowCreateOrgModal(false)} />
		</>
	);
}

export default observer(McpAuth);
